// This is only used in the experiment requiring login.
// Although the ApplicationController adds this when possible on the server side, we still need this for content rendered on the client side.
export function addLinkPaywallClasses() {
  if (!document.querySelector('#paywall-structured-data')) {
    return;
  }
  for (let root of [document].concat(_getShadowRoots(document.body))) {
    _addLinkPaywallClassesToRoot(root);
  }
}

function _addLinkPaywallClassesToRoot(root) {
  const links = root.querySelectorAll('a');
  for (let link of links) {
    link.classList.add('paywall');
  }
}

function _getShadowRoots(body) {
  return [body, ...body.querySelectorAll('*')].filter(
    element => !!element.shadowRoot
  ).flatMap(element => [element.shadowRoot, ..._getShadowRoots(element.shadowRoot)]);
}
